import React from "react";
import { FaGithub } from "react-icons/fa";
import { FiExternalLink } from "react-icons/fi";
import "./ProjectCard.css";

// model_card "eval result" style card.
// `tag` = the eval category (e.g. "Real-time ML"), `stack` = small mono label.
const ProjectCard = ({ image, title, description, tag, stack, github, liveDemo }) => {
  return (
    <div className="eval-card" data-aos="fade-up">
      {image && (
        <div className="eval-thumb">
          <img src={image} alt={title} loading="lazy" />
        </div>
      )}
      <div className="eval-body">
        {tag && <span className="eval-tag">{tag}</span>}
        <h3 className="eval-title">{title}</h3>
        <p className="eval-desc">{description}</p>
        {stack && <div className="eval-stack">⚙ {stack}</div>}
        <div className="eval-links">
          {github && (
            <a href={github} target="_blank" rel="noopener noreferrer">
              <FaGithub className="el-ic" /> GitHub →
            </a>
          )}
          {liveDemo && (
            <a href={liveDemo} target="_blank" rel="noopener noreferrer">
              <FiExternalLink className="el-ic" /> live demo →
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;